import Button from 'components/form/Button';
import Dropdown from 'components/form/Dropdown';
import Location from 'components/form/Location';
import TextInput from 'components/form/TextInput';
import UserDropdown from 'components/form/UserDropdown';
import AddAuthorPopup from 'components/Layout/AddAuthorPopup';
import AddCoAuthorPopup from 'components/Layout/AddCoAuthorPopup';
import Card from 'components/Layout/Card'
import NewUserDropdown from 'components/V2ForNewAbstractFlow/NewUserDropdown';
import { map } from 'lodash';
import React, { useState } from 'react'
import { useDispatch } from 'react-redux';
import { throwError } from 'store/slices';
import { dialCode, icons } from 'utils/constants';
import { convertString, numberOnlyFromInput } from 'utils/helpers';

const AuthorInformation = ({ values, setValues, handleChange, setFieldValue, errors, onBack, onNext, btnLoading
}) => {
    const dispatch = useDispatch()
    const { authors_email, author_name, is_email, co_authors } =
        values;
    const { authors_email: err_authors_email, authors: err_authors ,email_id} =
        errors;


    const [typedInvitedAuthor, setTypedInvitedAuthor] = useState('');
    const [showAddAuthorPopup, setShowAddAuthorPopup] = useState(false);

    return (
        <>
            {showAddAuthorPopup && (
                <AddAuthorPopup
                    id="invite_author_details"
                    setAuthorData={(e) => {
                        const isExist = co_authors?.some(
                            (o) => o.email === e?.value?.author_email_id
                        );
                        if (isExist) {
                            dispatch(
                                throwError({
                                    message: 'Email already exist in co-author.',
                                })
                            );
                            return;
                        }
                        setValues({
                            ...values,
                            authors: '',
                            author_name: e?.value?.author_name || '',
                            authors_email: e?.value?.author_email_id || '',
                            country_code: e?.value?.author_country_code || '',
                            author_phone: e?.value?.author_whatsapp_number || '',
                            author_country: e?.value?.author_country || '',
                            is_email: true,
                            email_id: e?.value?.author_email_id || '',
                            contact_number:
                                e?.value?.author_whatsapp_number || '',
                            whatsapp_number:
                                e?.value?.author_whatsapp_number || '',
                            country: e?.value?.author_country || '',
                        });
                        setShowAddAuthorPopup(false);
                    }}
                    onHide={() => {
                        setShowAddAuthorPopup(false);
                    }}
                    typedData={typedInvitedAuthor}
                />
            )}

            <Card className='cp-20'>
                <div className="text-16-500 color-1717 cmb-20">
                    Author Information
                </div>
                <div className="border-bottom cmb-20 color-d1d1"></div>

                <div className='row'>
                    <div className="col-md-4 cmb-24">
                        {is_email || authors_email ? (
                            <TextInput
                                isRequired
                                label="Email ID"
                                placeholder="Enter author email"
                                id="authors"
                                onChange={(e) => {
                                    handleChange(e);
                                }}
                                value={authors_email}
                                error={err_authors_email || email_id}
                                onBlur={() => {
                                    if (!err_authors_email) {
                                        const selectedEmail = authors_email;
                                        const isExist = co_authors?.some(
                                            (o) => o?.email === selectedEmail
                                        );
                                        if (isExist) {
                                            dispatch(
                                                throwError({
                                                    message: 'Email already exist in author.',
                                                })
                                            );
                                            setFieldValue('authors_email', '');
                                        }
                                    }
                                }}
                                handelCancel={() => {
                                    setValues({
                                        ...values,
                                        authors: '',
                                        author_name: '',
                                        authors_email: '',
                                        author_phone: '',
                                        author_country: '',
                                        is_email: '',
                                        email_id: '',
                                        contact_number: '',
                                        whatsapp_number: '',
                                        country: '',
                                    });
                                }}
                            />
                        ) : (
                            <UserDropdown
                                isShowEmail
                                isRequired
                                showOnSearch
                                label="Email ID"
                                id="authors"
                                placeholder="Author email"
                                value={values?.authors}
                                error={err_authors || email_id}
                                onChange={(e) => {
                                    const {
                                        id: selectedId,
                                        name: selectedName,
                                        email_id: selectedEmail,
                                        country_id: selectedCountryId,
                                        mobile_number: selectedMobileNumber,
                                    } = e?.target?.data;
                                    const isExist = co_authors?.some(
                                        (o) => o?.email === selectedEmail
                                    );
                                    if (isExist) {
                                        dispatch(
                                            throwError({
                                                message:
                                                    'Author already exist in co-author.',
                                            })
                                        );
                                    } else {
                                        setValues({
                                            ...values,
                                            authors: selectedId || '',
                                            author_name: selectedName || '',
                                            authors_email: selectedEmail || '',
                                            author_phone: selectedMobileNumber || '',
                                            author_country: selectedCountryId || '',
                                            is_email: false,
                                            email_id: selectedEmail || '',
                                            contact_number: selectedMobileNumber || '',
                                            whatsapp_number: selectedMobileNumber || '',
                                            country: selectedCountryId || '',
                                        });
                                        handleChange(e);
                                    }
                                }}
                                existingList={
                                    values?.authors
                                        ? [
                                            {
                                                id: values?.authors,
                                                name: values?.author_name || '',
                                                email_id: values?.authors_email || '',
                                                country_id: values?.author_country,
                                                mobile_number: values?.contact_number,
                                            },
                                        ]
                                        : []
                                }
                                handelInvite={(e) => {
                                    setTypedInvitedAuthor(e?.value);
                                    setValues({
                                        ...values,
                                        authors: '',
                                        author_name: '',
                                        authors_email: '',
                                        author_phone: '',
                                        author_country: '',
                                        is_email: '',
                                        email_id: '',
                                        contact_number: '',
                                        whatsapp_number: '',
                                        country: '',
                                    });
                                    setShowAddAuthorPopup(true);
                                }}
                            />
                        )}
                    </div>

                    {/* <div className="col-md-4 cmb-24">
                        <NewUserDropdown
                            showOnSearch
                            id="co_authors"
                            label="Co Authors"
                            placeholder="Co-Author email"
                            handleInvite={(e) => {
                                setTypedInvitedCoAuthor(e?.value);
                                setShowAddCoAuthorPopup(true);
                            }}
                            onChange={(e) => {
                                let oldData = JSON.parse(
                                    JSON.stringify(co_authors)
                                );
                                oldData.push({
                                    id: e?.target?.value?.id || '',
                                    email: e?.target?.value?.email_id || '',
                                    name: e?.target?.value?.name || '',
                                    country: e?.target?.value?.country_id || '',
                                    phone: e?.target?.value?.mobile_number || '',
                                });

                                setFieldValue('co_authors', oldData);
                            }}
                            handleDelete={(e) => {
                                let oldData = JSON.parse(
                                    JSON.stringify(co_authors)
                                )?.filter((_, i) => i !== e);
                                setFieldValue('co_authors', oldData);
                            }}
                            // existingList={map(co_authors, "name")}
                            existingList={map(co_authors, (CoAuthor) => ({
                                name: CoAuthor?.name,
                                email: CoAuthor?.email,
                                id: CoAuthor?.id,
                            }))}
                            existingAuthor={{
                                name: author_name || '',
                                email: authors_email || '',
                            }}
                        />
                    </div> */}

                    <div className="col-md-4 cmb-24">
                        {/* <TextInput
                            label="Email ID"
                            isRequired
                            id="email_id"
                            placeholder="Enter email id"
                            onChange={(e) => {
                                handleChange(convertString(1, e));
                            }}
                            value={values?.email_id}
                            error={errors?.email_id}
                        /> */}

                        <TextInput
                            IsIcon
                            icon={icons?.userOutline}
                            label="Author"
                            isRequired
                            id="author_name"
                            placeholder="Enter author name"
                            onChange={(e) => {
                                // handleChange(convertString(1, e));
                                handleChange(e);
                            }}
                            value={values?.author_name}
                            error={errors?.author_name}
                        />
                    </div>

                    <div className="col-md-4 cmb-24">
                        <TextInput
                            label="University"
                            value={values?.university}
                            error={errors?.university}
                            onChange={handleChange}
                            id="university"
                            placeholder="Enter University Name"
                        />
                    </div>

                    <div className="col-md-4 cmb-24">
                        <Location
                            type="country"
                            data={{
                                isRequired: true,
                                label: 'Country',
                                id: 'country',
                                placeholder: 'Select Country',
                                value: values?.country,
                                error: errors?.country,
                                // onChange: handleChange,
                                onChange: (e) => {
                                    handleChange(e);
                                    const selectedCountry = dialCode.find(
                                        (country) =>
                                            country?.name === e.target?.data?.country
                                    );

                                    if (selectedCountry) {
                                        setFieldValue(
                                            'country_code',
                                            selectedCountry.code
                                        );
                                        setFieldValue(
                                            'mobile_no_length',
                                            selectedCountry.phoneLength
                                        );
                                    } else {
                                        setFieldValue('country_code', '');
                                    }
                                },
                            }}
                        />
                    </div>
                    <div className="col-md-4 cmb-24">
                        <TextInput
                            isPhoneNumber
                            isRequired
                            label="Contact"
                            placeholder="Phone Number"
                            id="contact_number"
                            type="number"
                            value={values?.contact_number}
                            error={errors?.contact_number}
                            phoneNumberData={{
                                id: 'country_code',
                                value: values?.country_code,
                            }}
                            onChange={(e) => {
                                if (e.target.id === 'contact_number') {
                                    handleChange(numberOnlyFromInput(e));
                                } else {
                                    handleChange(e);
                                    handleChange({
                                        target: { id: 'contact_number', value: '' },
                                    });
                                    setFieldValue(
                                        'mobile_no_length',
                                        e.target.length
                                    );
                                }
                            }}
                        />
                    </div>
                    <div className="col-md-4 cmb-24">
                        <TextInput
                            IsIcon
                            type="number"
                            icon={icons?.whatsappOutline}
                            label="Whatsapp Number"
                            id="whatsapp_number"
                            onChange={handleChange}
                            value={values?.whatsapp_number}
                            error={errors?.whatsapp_number}
                        />
                    </div>

                      <div className="col-md-4 cmb-24">
                        <TextInput
                            // type="number"
                            label="ORCID ID (Optional)"
                            id="author_orcid_id"
                            onChange={handleChange}
                            value={values?.author_orcid_id}
                            error={errors?.author_orcid_id}
                            placeholder="0000-0000-0000-0000"
                        />
                    </div>
                     <div className="col-md-4 cmb-24">
                        <TextInput
                            // type="number"
                            label="Scopus ID (Optional)"
                            id="author_scopus_id"
                            onChange={handleChange}
                            value={values?.author_scopus_id}
                            error={errors?.author_scopus_id}
                            placeholder="Enter Scopus ID"
                        />
                    </div>

                    <div className="col-md-4 cmb-24">
                        <Dropdown
                            label="Choose your submission type to proceed*"
                            id="submission_category"
                            placeholder="Select"
                            options={[
                                { id: "Conference", label: "Conference" },
                                { id: "Conference + Publication", label: "Conference + Publication" }
                            ]}
                            onChange={handleChange}
                            value={values?.submission_category}
                            error={errors?.submission_category}
                        />
                    </div>

                </div>

                {/* <div className="d-flex gap-3 cmt-20">
                    {onBack && (
                        <Button
                            text="Back"
                            btnStyle="light-outline"
                            className="cps-40 cpe-40 h-38"
                            onClick={onBack}
                            disabled={btnLoading}
                        />
                    )}
                    <Button
                        text="Proceed Next"
                        btnStyle="primary-dark"
                        className="cps-40 cpe-40 h-38"
                        onClick={onNext}
                        btnLoading={btnLoading}
                        disabled={Object.keys(errors).length > 0 || btnLoading}
                    />
                </div> */}

            </Card>
        </>
    )
}

export default AuthorInformation
